import { render, staticRenderFns } from "./TransactionPin.vue?vue&type=template&id=34d762d1"
import script from "./TransactionPin.vue?vue&type=script&lang=js"
export * from "./TransactionPin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports